export default "__VITE_ASSET__Rt3yBAI7__"